import qs from 'qs'

export function ExpertExcel(that, url, queryData = {}, fileName = 'xxxx.xlsx') {
  const hide = that.$message.loading('数据正在导出, 请等待 ', 0)
  const out = setTimeout(() => {
    setTimeout(hide, 0)
    that.$message.error('请求数据超时', 3)
  }, 3000 * 6)
  that.$http.post(url, qs.stringify(queryData, { allowDots: true }), {
    responseType: 'blob', timeout: 30000 * 60
  }).then(res => {
    setTimeout(hide, 0)
    clearTimeout(out)
    let blob = new Blob([res], {
      type: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, fileName)
    } else {
      let elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      document.body.removeChild(elink)
    }
    that.$message.success('导出成功')
  }).catch(err => {
    console.warn(err)
  })
}
